import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MessageService } from 'primeng/api';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { TikTokOauthResponse } from 'src/app/services/product.service';

@Component({
  selector: 'app-tiktok-auth',
  templateUrl: './tiktok-auth.component.html',
  styleUrls: ['./tiktok-auth.component.scss'],
  providers: [MessageService]
})
export class TiktokAuthComponent implements OnInit {
  loading = true;
  errorMessage = '';
  private tiktokData: TikTokOauthResponse | null = null;
  private selectedStoreId = '';

  constructor(
    private route: ActivatedRoute,
    private errorHandler: ErrorHandlerService,
    private productService: ProductService,
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  private ensureStorageFromOpener(): Promise<void> {
    return new Promise((resolve) => {
      try {
        const ch = new BroadcastChannel('oauth-storage');
        const timeout = setTimeout(() => { ch.close(); resolve(); }, 800);
        ch.onmessage = (e) => {
          if (e.data?.type === 'storage-dump') {
            const p = e.data.payload || {};
            for (const k of Object.keys(p)) {
              if (p[k] != null) localStorage.setItem(k, String(p[k]));
            }
            clearTimeout(timeout);
            ch.close();
            resolve();
          }
        };
        ch.postMessage({ type: 'request-storage' });
      } catch { resolve(); }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      await this.ensureStorageFromOpener();

      const code = params['code'] || params['auth_code'];
      const state = params['state'];
      const error = params['error'];

      if (state) {
        try {
          const stateObj = JSON.parse(atob(state));
          this.selectedStoreId = stateObj.selectedStoreId || '';
          if (this.selectedStoreId) localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);
          if (stateObj.accessToken) localStorage.setItem('access_token', stateObj.accessToken);
        } catch (e) {
          console.warn('State inválido', e);
        }
      }

      if (!this.selectedStoreId) {
        this.selectedStoreId = localStorage.getItem('ss_SelectedStoreId') || '';
      }

      if (error) {
        this.showError('Autorização negada pelo usuário.');
        return;
      }

      if (code && state) this.finishTiktokLogin(code, state);
    });
  }

  private finishTiktokLogin(code: string, state: string) {
    this.productService.tiktokOauth(code, state).pipe(
      catchError(() => {
        this.showError('Não foi possível autenticar no TikTok.');
        return EMPTY;
      })
    ).subscribe(data => {
      this.tiktokData = data;
      this.autoIntegrate();
    });
  }

  private autoIntegrate() {
    if (!this.selectedStoreId || !this.tiktokData) {
      this.showError('Loja não identificada. Tente novamente.');
      return;
    }

    localStorage.setItem('ss_SelectedStoreId', this.selectedStoreId);

    const payload = {
      access_token: this.tiktokData.access_token,
      refresh_token: this.tiktokData.refresh_token,
      expires_in: this.tiktokData.expires_in,
      username: this.tiktokData.username ?? null,
      avatar_url: this.tiktokData.avatar_url ?? null,
      avatar_url_100: this.tiktokData.avatar_url_100 ?? null,
      avatar_large_url: this.tiktokData.avatar_large_url ?? null,
      status: 'active',
      form_value: {
        open_id: this.tiktokData.open_id,
        union_id: this.tiktokData.union_id,
        name: this.tiktokData.display_name ?? this.tiktokData.username ?? 'TikTok User',
        picture: this.tiktokData.avatar_large_url || this.tiktokData.avatar_url || this.tiktokData.avatar_url_100 || null,
      },
    };

    this.productService.createAppsStore2('tiktok', payload).pipe(
      catchError(() => {
        this.showError('Não foi possível salvar integração.');
        return EMPTY;
      })
    ).subscribe(() => {
      this.loading = false;
      // const isAndroid = /android/i.test(navigator.userAgent);
      // if (isAndroid) {
      //   window.location.href = 'myslick://auth/tiktok?result=success';
      //   return;
      // }
      try {
        const channel = new BroadcastChannel('oauth-channel');
        channel.postMessage({ type: 'tiktok-connected' });
        channel.close();
      } catch {}
      try { window.close(); } catch {}
    });
  }

  private showError(msg: string) {
    this.loading = false;
    this.errorMessage = msg;
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: msg });
    setTimeout(() => { try { window.close(); } catch {} }, 3000);
  }
}
